if (!customElements.get('podium-founder-video')) {
  customElements.define('podium-founder-video', class extends HTMLElement {
    connectedCallback() {
      this.wide = this.querySelector('.pc-founder-wide');
      this.square = this.querySelector('.pc-founder-square');
      if (!this.wide || !this.square) return;
      this.breakpoint = window.matchMedia('(max-width: 600px)');
      this.player = this.breakpoint.matches ? this.square : this.wide;
      this.onBreakpoint = () => this.switchPlayer();
      this.breakpoint.addEventListener('change', this.onBreakpoint);
    }

    disconnectedCallback() {
      this.breakpoint?.removeEventListener('change', this.onBreakpoint);
      this.wide?.pause();
      this.square?.pause();
    }

    switchPlayer() {
      const next = this.breakpoint.matches ? this.square : this.wide;
      if (this.player === next) return;
      const previous = this.player;
      const position = previous.currentTime;
      const wasPlaying = !previous.paused && !previous.ended;
      previous.pause();
      this.player = next;
      next.volume = previous.volume;
      next.muted = previous.muted;
      next.playbackRate = previous.playbackRate;

      // CSS chooses the visible format even before JavaScript loads. Only a
      // viewer who has started playback needs the alternate video to load.
      if (position > 0 || wasPlaying) {
        const restore = () => {
          if (this.player !== next || !this.isConnected) return;
          next.currentTime = Math.min(position, next.duration);
          if (wasPlaying) next.play().catch(() => {});
        };
        if (next.readyState >= 1) restore();
        else {
          next.addEventListener('loadedmetadata', restore, { once: true });
          next.load();
        }
      }
    }
  });
}
